<template>
  <div class="container">
    <van-nav-bar
      :title="title"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      @click-right="onClickRight"
      class="navbar"
    >
      <van-icon name="search" size="18" slot="right" />
    </van-nav-bar>
    <!-- 订单列表 -->
    <g-orderlist
      :data="list"
      @loadmore="onLoadMore"
      @change="onChangeStatus"
      type="merch"
      @pullingDown="onPullingDown"
      :page="page"
      :totalpage="totalpage"
      @cancelorder="onCancelOrder"
      @todetail="onToDetail"
    />
    <!-- 搜索 -->
    <van-action-sheet v-model="show" :actions="actions" @select="onSelect" />
    <van-action-sheet v-model="isordersn" title="按订单号搜索">
      <van-cell-group>
        <van-field v-model="ordersn" placeholder="请输入订单号">
          <van-button slot="button" size="small" type="primary" @click="onSearch">查询</van-button>
        </van-field>
      </van-cell-group>
    </van-action-sheet>
    <fade-animation v-if="isdateshow">
      <div class="overlay"></div>
    </fade-animation>
    <slidedown-animation v-if="isdateshow">
      <van-datetime-picker
        class="datetime-picker"
        v-model="currentDate"
        @confirm="onConfirm"
        @cancel="onCancel"
        type="date"
      />
    </slidedown-animation>
  </div>
</template>
<script>
import { OrderModel } from "@models/common/order";
import { ERR_OK } from "@/common";
import GOrderlist from "@components/orderlist/index";
import SlidedownAnimation from "@components/slide/SlidedownAnimation";
import FadeAnimation from "@components/fade/FadeAnimation";
const orderModel = new OrderModel();
export default {
  data() {
    return {
      title: "订单列表",
      status: "",
      keyword: "",
      list: [],
      totalpage: 1,
      page: 1,
      show: false,
      isordersn: false,
      isdateshow: false,
      ordersn: "",
      actions: [
        { name: "重置", type: "reset" },
        { name: "订单号", type: "ordersn" },
        { name: "日期", type: "date" }
      ],
      currentDate: ''
    };
  },
  components: {
    GOrderlist,
    SlidedownAnimation,
    FadeAnimation
  },
  methods: {
    onClickLeft() {
      this.$redirect("/home/index");
    },
    onClickRight() {
      this.show = true;
    },
    onSelect(item) {
      if(item.type == 'reset') {
        this.ordersn = ''
        this.currentDate = ''
        this.show = false;
      }
      if (item.type == "ordersn") {
        this.isordersn = true;
        this.show = false;
      }

      if (item.type == "date") {
        this.isdateshow = true;
        this.show = false;
        this.currentDate = new Date()
      }
    },
    onSearch() {
      this.get_list()
      this.isordersn = false
    },
    onConfirm() {
      this.isdateshow = false;
      this.get_list({
        date: this.currentDate,
      })
    },
    onCancel() {
      this.isdateshow = false;
    },
    onPullingDown() {
      setTimeout(() => {
        this.list = [];
        this.page = 1;
        this.get_list();
      }, 1000);
    },
    onCancelOrder(id) {
      this.$dialog
        .confirm({
          message: "确定要取消该订单?",
          cancelButtonText: "取消",
          confirmButtonText: "确定"
        })
        .then(() => {
          orderModel
            .cancelOrder({
              id: id,
              user_token: localStorage.user_token
            })
            .then(res => {
              if (res.code == ERR_OK) {
                this.$toast("取消成功");
                setTimeout(() => {
                  this.get_list();
                }, 3000);
              }
            });
        })
        .catch(() => {});
    },
    onChangeStatus(status) {
      this.status = status;
      this.list = [];
      this.page = 1;
      this.get_list();
    },
    onLoadMore(status) {
      this.status = status;
      this.page++;
      this.get_list();
    },
    get_list(params = {}) {
      this.list = [];
      let obj = {
        type: "merch",
        merchid: localStorage.id,
        status: this.status,
        date: this.currentDate,
        ordersn: this.ordersn,
        parentid: this.$route.params.id
      };
      Object.assign(obj, params);
      orderModel.get_order_list(obj).then(res => {
        if (res.code == ERR_OK) {
          this.totalpage = res.data.last_page;
          this.list = this.list.concat(res.data.data);
        }
      });
    },
    onToDetail(orderid) {
      this.$redirect(`/home/order/detail/${orderid}`);
    }
  },
  created() {},
  activated() {
    this.get_list();
  }
};
</script>

<style lang="stylus" scoped>
.container {
  background: #f2f3f5;
}

.order-item {
  margin-bottom: 0.2rem;
}

>>>.van-cell__title {
  -webkit-box-flex: auto;
  -webkit-flex: auto;
  flex: auto;
  width: 4rem;
}

>>>.van-panel__content {
  padding: 0.2rem 0.3rem;
}

.order-info p {
  line-height: 1.8;
  color: #aaa;
}

.order-footer {
  display: flex;
  justify-content: flex-end;
}

.order-status-container {
  width: 100%;
  height: 0.86rem;
  background: #fff;
  position: fixed;
  top: 0.92rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.status-item {
  width: 25%;
  height: 100%;
  line-height: 0.86rem;
  text-align: center;
  color: #aaa;
}

.status-item.active {
  color: #000;
}

.scroll-wrap {
  height: calc(100% - 2rem);
  position: fixed;
  top: 2rem;
  width: 100%;
}

.navbar {
  color: #fff;
  background: #2196f3;
  position: fixed;
  top: 0;
  width: 100%;
}

>>>.status0 .van-panel__header-value span {
  padding: 0.1rem 0.2rem;
  background: #f60;
  color: #fff;
  border-radius: 5px;
}

>>>.status1 .van-panel__header-value span {
  padding: 0.1rem 0.2rem;
  background: #67c23a;
  color: #fff;
  border-radius: 5px;
}

>>>.status_1 .van-panel__header-value span {
  padding: 0.1rem 0.2rem;
  background: #ccc;
  color: #fff;
  border-radius: 5px;
}

>>>.van-nav-bar__title, .van-nav-bar .van-icon, .van-nav-bar__text {
  color: #fff;
}

.overlay {
  width: 100%;
  height: 100%;
  z-index: 998;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
}

.datetime-picker {
  width: 100%;
  z-index: 999;
  position: fixed;
  bottom: 0;
  left: 0;
}

.order-buttons button {
  margin-left: 0.2rem;
}
</style>